/* Reviews page (sections/reviews-page.liquid). No dependencies, runs after parsing (defer).
   - Photo wall: 12 photos at a time; after the server-rendered ones, more photo reviews come from Judge.me.
   - Review list: filters (all / with photos / stars), sorting, «Mehr laden» in batches of 24 from Judge.me's public widget
     endpoint (the same data the Judge.me widget uses; the reviews stay in Judge.me). Text is read from the returned HTML
     with a <template> (nothing runs, no image loads) and rebuilt in our markup (same as snippets/rvp-review).
   - Grids never leave holes: a batch is cut to full rows while more can come; at the end a short last row gets a tile.
   - Photos open the shared review popup of assets/plp-tattup.js (data-plpb-lb + <template data-plpb-lb-data>).
   - ?view=reviews-write: opens Judge.me's «write a shop review» form right away. */
(function () {
  'use strict';

  var PER = 24;

  /* ---------- write view: open Judge.me's own form ---------- */
  var writeRoot = document.querySelector('[data-rvp-write]');
  if (writeRoot) {
    document.documentElement.classList.add('rvp-writing');
    /* Judge.me's widget (app section with the class rvp-jdgm) moves into the form column of our layout once its form is
       open, and only on desktop (two columns): on phones Judge.me sets the form up only when it scrolls into view. The element is moved as a whole, so Judge.me's
       handlers (stars, upload, validation, submit) keep working; until then it stays invisible (CSS .rvp-writing). */
    var slot = writeRoot.querySelector('[data-rvp-slot]');
    var place = function () {
      var jm = document.querySelector('.rvp-jdgm');
      // phones / tablets: one column, Judge.me's section already sits right under the intro – it stays where it is
      if (slot && jm && !slot.contains(jm) && window.matchMedia('(min-width: 990px)').matches) slot.appendChild(jm);
    };
    /* «Bewertung abbrechen» leads back to the reviews (Judge.me would only close the form and leave an empty page) */
    document.addEventListener('click', function (e) {
      var c = e.target.closest && e.target.closest('.rvp-jdgm .jdgm-cancel-rev');
      var back = writeRoot.querySelector('.rvp-back');
      if (c && back) { e.preventDefault(); e.stopPropagation(); location.href = back.href; }
    }, true);
    var tries = 0;
    var openForm = function () {
      var link = document.querySelector('.jdgm-write-rev-link');
      var form = document.querySelector('.jdgm-form-wrapper, .jdgm-form');
      if (form && form.offsetParent !== null) {
        /* form is open: hide Judge.me's review list on this view (the list is on the main page) */
        place();
        document.documentElement.classList.add('rvp-writing--open');
        return true;
      }
      if (link && link.offsetParent !== null && !link.__rvp) { link.__rvp = true; link.click(); }
      return false;
    };
    var iv = setInterval(function () {
      tries++;
      // Judge.me may set its widget up only when it scrolls into view (phones): keep checking for 3 minutes
      if (openForm() || tries > 720) {
        clearInterval(iv);
        place();
        document.documentElement.classList.add('rvp-writing--ready');
      }
    }, 250);
    return;
  }

  var root = document.getElementById('rvp');
  if (!root) return;

  /* links from Judge.me e-mails (tokens) need Judge.me's form: send them to the write view */
  if (/judgeme_(token|review_uuid|dynamic_form|follow_up_token|upload_pictures|pre_verified)/.test(location.search) || location.hash === '#judgeme') {
    location.replace(root.dataset.write + (location.search ? '&' + location.search.slice(1) : '') + location.hash);
    return;
  }

  var T = {};
  try { T = JSON.parse(root.querySelector('[data-rvp-i18n]').textContent); } catch (e) {}
  var lang = root.dataset.lang === 'de' ? 'de' : 'en';
  var total = parseInt(root.dataset.total, 10) || 0;
  var api = root.dataset.api;

  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  };
  var num = function (n) {
    try { return new Intl.NumberFormat(lang === 'de' ? 'de-CH' : 'en-US').format(n); } catch (e) { return String(n); }
  };
  var fmtDate = function (s) {
    var d = new Date(String(s || '').replace(' UTC', 'Z').replace(' ', 'T'));
    if (isNaN(d)) return { txt: '', iso: '' };
    var o = lang === 'de' ? { day: '2-digit', month: '2-digit', year: 'numeric', timeZone: 'Europe/Zurich' } : { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'Europe/Zurich' };
    var txt = '';
    try { txt = new Intl.DateTimeFormat(lang === 'de' ? 'de-CH' : 'en-US', o).format(d); } catch (e) { txt = d.toLocaleDateString(); }
    return { txt: txt, iso: d.toISOString().slice(0, 10) };
  };
  /* same markup as snippets/tt-stars (integer ratings) */
  var stars = function (n, size) {
    var s = '<svg class="tt-stars" viewBox="0 0 136 24" width="' + (size * 136 / 24).toFixed(1) + '" height="' + size + '" role="img" aria-label="' + esc((T.stars || '%n / 5').replace('%n', n)) + '"><g class="tt-stars__on">';
    for (var i = 0; i < 5; i++) s += (i === n ? '</g><g class="tt-stars__off">' : '') + '<use href="#tt-star" width="24" height="24" x="' + i * 28 + '"/>';
    return s + '</g></svg>';
  };
  var picBase = function (u) {
    var i = u.indexOf('width=');
    if (i > -1) return u.slice(0, i);
    return u + (u.indexOf('?') > -1 ? '&' : '?');
  };
  var text = function (s) { return esc(s).replace(/\n/g, '<br>'); };

  /* Judge.me widget HTML → plain review objects */
  var parse = function (html) {
    var t = document.createElement('template');
    t.innerHTML = html || '';
    return Array.prototype.map.call(t.content.querySelectorAll('.jdgm-rev'), function (el) {
      var q = function (s) { return el.querySelector(s); };
      var b = q('.jdgm-rev__body');
      var paras = b ? Array.prototype.map.call(b.querySelectorAll('p'), function (p) { return p.textContent.trim(); }).filter(Boolean) : [];
      var rating = q('.jdgm-rev__rating');
      var ts = q('.jdgm-rev__timestamp');
      var pics = Array.prototype.map.call(el.querySelectorAll('.jdgm-rev__pic-link'), function (a) { return a.getAttribute('data-mfp-src') || a.getAttribute('href') || ''; })
        .filter(function (u) { return /^https:\/\/[a-z0-9.-]*judge(\.)?me[a-z0-9.-]*\//i.test(u); });
      return {
        id: el.getAttribute('data-review-id') || '',
        rating: Math.max(1, Math.min(5, parseInt(rating && rating.getAttribute('data-score'), 10) || 5)),
        date: ts ? ts.getAttribute('data-content') : '',
        name: ((q('.jdgm-rev__author') || {}).textContent || '').trim(),
        title: ((q('.jdgm-rev__title') || {}).textContent || '').trim(),
        body: paras.length ? paras.join('\n') : ((b || {}).textContent || '').trim(),
        reply: ((q('.jdgm-rev__reply-content') || {}).textContent || '').trim(),
        verified: el.getAttribute('data-verified-buyer') === 'true',
        pics: pics
      };
    });
  };

  var lbHtml = function (r, name, d) {
    var h = '<template data-plpb-lb-data><div class="plpb-lb__pics">';
    r.pics.forEach(function (u) { h += '<img src="' + esc(picBase(u) + 'width=1024') + '" alt="" decoding="async">'; });
    h += '</div><div class="plpb-lb__text">' + stars(r.rating, 18);
    if (r.title) h += '<p class="plpb-lb__title">' + esc(r.title) + '</p>';
    h += '<p class="plpb-lb__body">' + text(r.body) + '</p>';
    if (r.reply) h += '<p class="rvp-reply"><b>' + esc(T.reply) + '</b>' + esc(r.reply) + '</p>';
    h += '<p class="plpb-lb__who"><b>' + esc(name) + '</b>' + (r.verified ? ' · ' + esc(T.verified) : '') + '<span>' + esc(d.txt) + '</span></p></div></template>';
    return h;
  };
  var openLabel = function (name) { return esc((T.open || '') + ': ' + name); };

  var cardHtml = function (r) {
    var name = r.name || T.anon || '';
    var d = fmtDate(r.date);
    var pic = r.pics.length > 0;
    var h = '<li class="rvp-card rvp-card--' + (pic ? 'pic' : 'text') + '" data-id="' + esc(r.id) + '">';
    if (pic) {
      var base = esc(picBase(r.pics[0]));
      h += '<button type="button" class="rvp-card__img" data-plpb-lb aria-haspopup="dialog" aria-label="' + openLabel(name) + '">' +
        '<img src="' + base + 'width=640" srcset="' + base + 'width=400 400w, ' + base + 'width=640 640w, ' + base + 'width=1024 1024w" sizes="(min-width: 1100px) 420px, (min-width: 700px) 46vw, 92vw" alt="" width="640" height="480" loading="lazy" decoding="async">' +
        (r.pics.length > 1 ? '<span class="rvp-tile__n">1/' + r.pics.length + '</span>' : '') + '</button>' + lbHtml(r, name, d);
    }
    h += '<div class="rvp-card__body"><div class="rvp-card__top">' + stars(r.rating, 15) + '<time datetime="' + d.iso + '">' + esc(d.txt) + '</time></div>';
    if (r.title) h += '<p class="rvp-card__t">' + esc(r.title) + '</p>';
    h += '<p class="rvp-card__q">' + text(r.body) + '</p>';
    if (r.reply) h += '<p class="rvp-reply" hidden><b>' + esc(T.reply) + '</b>' + esc(r.reply) + '</p>';
    h += '<button type="button" class="rvp-card__more" data-rvp-more aria-expanded="false" hidden>' + esc(T.more) + '</button>';
    h += '<p class="rvp-card__who"><b>' + esc(name) + '</b>' + (r.verified ? '<span>' + esc(T.verified) + '</span>' : '') + '</p></div></li>';
    return h;
  };
  var tileHtml = function (r) {
    var name = r.name || T.anon || '';
    var base = esc(picBase(r.pics[0]));
    return '<li class="rvp-tile" data-id="' + esc(r.id) + '" hidden><button type="button" class="rvp-tile__btn" data-plpb-lb aria-haspopup="dialog" aria-label="' + openLabel(name) + '">' +
      '<img src="' + base + 'width=400" srcset="' + base + 'width=240 240w, ' + base + 'width=400 400w, ' + base + 'width=640 640w" sizes="(min-width: 1400px) 216px, (min-width: 990px) 16vw, (min-width: 600px) 24vw, 32vw" alt="" width="400" height="400" loading="lazy" decoding="async">' +
      (r.pics.length > 1 ? '<span class="rvp-tile__n">1/' + r.pics.length + '</span>' : '') + '</button>' + lbHtml(r, name, fmtDate(r.date)) + '</li>';
  };
  var append = function (ul, html) {
    var t = document.createElement('template');
    t.innerHTML = html;
    ul.appendChild(t.content);
  };

  var fetchPage = function (params, page) {
    return fetch(api + '&per_page=' + PER + '&page=' + page + (params ? '&' + params : ''), { credentials: 'omit' })
      .then(function (res) { if (!res.ok) throw new Error(res.status); return res.json(); })
      .then(function (j) { return parse(j && j.html); });
  };

  var cols = function (el) {
    return Math.max(1, getComputedStyle(el).gridTemplateColumns.split(' ').filter(Boolean).length);
  };
  var fillTile = function (span, wall) {
    var li = document.createElement('li');
    li.className = 'rvp-fill';
    li.setAttribute('data-fill', '');
    li.style.gridColumn = 'span ' + span;
    li.innerHTML = '<p>' + esc(T.fill_t) + '</p><a class="rvp-btn' + (wall ? '' : ' rvp-btn--ghost') + '" href="' + esc(root.dataset.write) + '">' + esc(T.fill_b) + '</a>';
    return li;
  };

  var relayout = function () {};

  /* ---------- mehr / weniger on the cards ---------- */
  var checkMore = function (scope) {
    (scope || root).querySelectorAll('.rvp-card:not(.is-open)').forEach(function (li) {
      var q = li.querySelector('.rvp-card__q');
      var btn = li.querySelector('[data-rvp-more]');
      if (!q || !btn) return;
      btn.hidden = !(q.scrollHeight > q.clientHeight + 2 || li.querySelector('.rvp-reply'));
    });
  };
  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rvp-more]');
    if (!btn) return;
    var li = btn.closest('.rvp-card');
    var open = li.classList.toggle('is-open');
    btn.textContent = open ? T.less : T.more;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    relayout();
  });

  /* ---------- photo wall ---------- */
  var wall = root.querySelector('[data-rvp-wall]');
  var wallBtn = root.querySelector('[data-rvp-wall-more]');
  var W = { page: 0, done: false, busy: false, seen: {} };
  var wallLayout = function () {
    if (!wall) return;
    var old = wall.querySelector('[data-fill]');
    if (old) old.remove();
    var hidden = wall.querySelectorAll('.rvp-tile[hidden]').length;
    if (wallBtn) wallBtn.hidden = W.done && hidden === 0;
    if (!W.done || hidden > 0) return;
    var shown = wall.querySelectorAll('.rvp-tile:not([hidden])').length;
    var c = cols(wall);
    var rest = shown % c;
    if (rest) wall.appendChild(fillTile(c - rest, true));
  };
  var wallReveal = function (n) {
    var list = wall.querySelectorAll('.rvp-tile[hidden]');
    for (var i = 0; i < list.length && i < n; i++) list[i].hidden = false;
  };
  var wallLoad = function () {
    /* more photo reviews: «pictures first» order, stop at the first review without a photo */
    var guard = 0;
    var step = function () {
      if (W.done || guard++ > 4 || wall.querySelectorAll('.rvp-tile[hidden]').length >= 12) return Promise.resolve();
      W.page++;
      return fetchPage('sort_by=pictures_first', W.page).then(function (list) {
        var html = '';
        if (list.length < PER) W.done = true;
        list.forEach(function (r) {
          if (!r.pics.length) { W.done = true; return; }
          if (W.seen[r.id]) return;
          W.seen[r.id] = 1;
          html += tileHtml(r);
        });
        if (html) append(wall, html);
        return step();
      });
    };
    return step();
  };
  if (wall) {
    wall.querySelectorAll('.rvp-tile').forEach(function (li) { W.seen[li.getAttribute('data-id')] = 1; });
    if (wallBtn) wallBtn.addEventListener('click', function () {
      if (W.busy) return;
      var hidden = wall.querySelectorAll('.rvp-tile[hidden]').length;
      if (hidden >= 12 || W.done) { wallReveal(12); wallLayout(); return; }
      W.busy = true;
      wallBtn.setAttribute('aria-busy', 'true');
      wallLoad().catch(function () { W.done = true; }).then(function () {
        W.busy = false;
        wallBtn.removeAttribute('aria-busy');
        wallReveal(12);
        wallLayout();
      });
    });
    wallLayout();
  }

  /* ---------- review list ---------- */
  var grid = root.querySelector('[data-rvp-grid]');
  var moreBtn = root.querySelector('[data-rvp-more-list]');
  var status = root.querySelector('[data-rvp-status]');
  var chips = root.querySelector('[data-rvp-chips]');
  var sortSel = root.querySelector('[data-rvp-sort]');
  if (!grid) return;
  var initial = { html: grid.innerHTML, status: status ? status.textContent : '' };
  var L = { f: 'all', sort: '', page: 0, done: false, busy: false, seen: {}, req: 0 };
  var markSeen = function () {
    L.seen = {};
    grid.querySelectorAll('.rvp-card').forEach(function (li) { L.seen[li.getAttribute('data-id')] = 1; });
  };
  markSeen();
  var params = function () {
    if (L.f === 'photos') return 'sort_by=pictures_first';
    var p = L.sort;
    if (/^[1-5]$/.test(L.f)) p += (p ? '&' : '') + 'filter_rating=' + L.f;
    return p;
  };
  var filterTotal = function () {
    if (L.f === 'all') return total;
    var chip = chips && chips.querySelector('[data-f="' + L.f + '"] small');
    return chip ? parseInt(chip.textContent, 10) || 0 : 0;
  };
  /* Balanced masonry (2 + 3 columns): every card spans as many 4 px rows as it is tall, so photo and text cards pack
     without holes; at the bottom every column ends on the same line – a small difference stretches the last card,
     a big one gets the «write a review» tile. One column: plain list. */
  var UNIT = 4;
  var GAP = 16;
  var mason = function () {
    grid.querySelectorAll('[data-fill]').forEach(function (f) { f.remove(); });
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.rvp-card'));
    var c = cols(grid);
    cards.forEach(function (el) { el.style.gridRowEnd = ''; el.classList.remove('is-last'); });
    grid.classList.toggle('is-mason', c > 1);
    if (c < 2 || !cards.length) return;
    var hs = cards.map(function (el) { return el.getBoundingClientRect().height; });
    var spans = hs.map(function (h) { return Math.ceil((h + GAP) / UNIT); });
    cards.forEach(function (el, i) { el.style.gridRowEnd = 'span ' + spans[i]; });
    var top = grid.getBoundingClientRect().top;
    var last = {};
    cards.forEach(function (el, i) {
      var r = el.getBoundingClientRect();
      var k = Math.round(r.left);
      var end = Math.round((r.top - top) / UNIT) + 1 + spans[i];
      if (!last[k] || end > last[k].end) last[k] = { el: el, end: end, i: i };
    });
    var keys = Object.keys(last).map(Number).sort(function (a, b) { return a - b; });
    var max = 0;
    keys.forEach(function (k) { max = Math.max(max, last[k].end); });
    keys.forEach(function (k, ci) {
      var o = last[k];
      var d = max - o.end;
      if (d * UNIT >= 180) {
        var f = fillTile(1, false);
        f.style.gridColumn = String(ci + 1);
        f.style.gridRow = o.end + ' / ' + max;
        grid.appendChild(f);
      } else {
        o.el.style.gridRowEnd = 'span ' + (spans[o.i] + d);
        o.el.classList.add('is-last');
      }
    });
  };
  var listLayout = function () {
    var n = grid.querySelectorAll('.rvp-card').length;
    var keep = n;
    checkMore(grid);
    mason();
    if (moreBtn) moreBtn.hidden = L.done;
    if (status) {
      var tot = filterTotal();
      if (!n) status.textContent = '';
      else if (L.done) status.textContent = (T.count || '%s').replace('%s', num(keep));
      else if (tot) status.textContent = (T.shown || '%s / %t').replace('%s', num(keep)).replace('%t', num(tot));
      else status.textContent = '';
    }
  };
  relayout = function () { mason(); };
  var load = function () {
    var req = ++L.req;
    var added = 0;
    var guard = 0;
    var step = function () {
      if (L.done || added >= PER || guard++ > 4) return Promise.resolve();
      L.page++;
      return fetchPage(params(), L.page).then(function (list) {
        if (req !== L.req) return;
        var html = '';
        var fresh = 0;
        if (list.length < PER) L.done = true;
        list.forEach(function (r) {
          if (L.done && L.f === 'photos' && !r.pics.length) return;
          if (L.f === 'photos' && !r.pics.length) { L.done = true; return; }
          if (!r.id || L.seen[r.id]) return;
          L.seen[r.id] = 1;
          fresh++;
          html += cardHtml(r);
        });
        /* a page with nothing new (the endpoint repeats its last page) = the end */
        if (!fresh && L.page > 1) L.done = true;
        added += fresh;
        if (html) append(grid, html);
        return step();
      });
    };
    L.busy = true;
    grid.setAttribute('aria-busy', 'true');
    if (moreBtn) { moreBtn.setAttribute('aria-busy', 'true'); moreBtn.dataset.label = moreBtn.dataset.label || moreBtn.textContent; moreBtn.textContent = T.loading; }
    return step().then(function () {
      if (req !== L.req) return;
      if (!grid.querySelector('.rvp-card')) grid.innerHTML = '<li class="rvp-empty">' + esc(T.empty) + '</li>';
    }, function () {
      if (req !== L.req) return;
      if (status) status.textContent = T.error;
    }).then(function () {
      if (req !== L.req) return;
      L.busy = false;
      grid.setAttribute('aria-busy', 'false');
      if (moreBtn) { moreBtn.removeAttribute('aria-busy'); moreBtn.textContent = moreBtn.dataset.label; }
      listLayout();
      if (status && !grid.querySelector('.rvp-card') && L.done) status.textContent = '';
    });
  };
  if (moreBtn) moreBtn.addEventListener('click', function () {
    if (L.busy) return;
    /* parked cards (cut to full rows) count towards the next batch */
    load();
  });

  var setFilter = function (f, sort) {
    L.f = f;
    if (sort != null) L.sort = sort;
    if (chips) chips.querySelectorAll('[data-f]').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.f === f ? 'true' : 'false'); });
    if (sortSel) sortSel.disabled = f === 'photos';
    L.req++;
    L.page = 0;
    L.done = false;
    L.busy = false;
    if (f === 'all' && !L.sort) {
      /* back to the start: the server-rendered first batch */
      grid.innerHTML = initial.html;
      markSeen();
      grid.setAttribute('aria-busy', 'false');
      if (moreBtn) { moreBtn.removeAttribute('aria-busy'); if (moreBtn.dataset.label) moreBtn.textContent = moreBtn.dataset.label; }
      listLayout();
      return;
    }
    grid.innerHTML = '';
    L.seen = {};
    if (status) status.textContent = T.loading;
    load();
  };
  if (chips) chips.addEventListener('click', function (e) {
    var b = e.target.closest('[data-f]');
    if (!b || b.getAttribute('aria-pressed') === 'true') return;
    setFilter(b.dataset.f);
    /* keep the chosen chip in view on phones */
    if (chips.scrollWidth > chips.clientWidth) b.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
  });
  if (sortSel) sortSel.addEventListener('change', function () { setFilter(L.f, sortSel.value); });
  root.addEventListener('click', function (e) {
    var go = e.target.closest('[data-rvp-go]');
    if (!go) return;
    var f = go.getAttribute('data-rvp-go');
    var list = document.getElementById('rvp-list');
    if (list) list.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (L.f !== f) setFilter(f);
  });

  var rt;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(function () { wallLayout(); listLayout(); }, 150);
  });
  listLayout();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { checkMore(grid); mason(); });
  /* photos with a fixed ratio do not change the height, but late web fonts can */
  window.addEventListener('load', function () { mason(); });
})();
